<template>
  <div
    row
    wrap
    class="user-detail-component"
  >
    <v-expansion-panel
      v-model="panel"
      class="my-2"
      expand
    >
      <!-- Information start -->
      <v-expansion-panel-content>
        <template v-slot:header>
          <h6 class="title">
            <v-icon
              class="mr-2"
            >
              assignment_ind
            </v-icon>
            User Information
          </h6>
        </template>
        <v-layout>
          <v-spacer />

          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <v-btn
                fixed
                dark
                fab
                bottom
                right
                color="warning"
                :disabled="!unsavedData"
                v-on="on"
                @click="openSaveUserDataModal"
              >
                <v-icon>save</v-icon>
              </v-btn>
            </template>
            <span>Save user data</span>
          </v-tooltip>


          <v-btn
            style="color: white"
            color="blue"
            :disabled="!unsavedData"
            @click="openSaveUserDataModal"
          >
            <v-icon medium>
              save
            </v-icon>
            &nbsp; SAVE USER DATA
          </v-btn>
        </v-layout>
        <v-card>
          <v-container
            fluid
            grid-list-sm
          >
            <v-layout
              row
              wrap
            >
              <v-flex
                xs6
                sm2
              >
                <user-info
                  label="ID"
                  :value="user.id"
                  readonly
                />
              </v-flex>
              <v-flex
                xs6
                sm2
              >
                <v-select
                  v-model="user.title"
                  :items="titlesArray"
                  item-text="name"
                  item-value="value"
                  label="Title"
                  @change="e => onSelectChange(e, 'title')"
                />
              </v-flex>
              <v-flex
                xs12
                sm4
              >
                <user-info
                  name="first_name"
                  label="First Name"
                  :value="user.first_name"
                  :on-change="onChange"
                />
              </v-flex>
              <v-flex
                xs12
                sm4
              >
                <user-info
                  name="last_name"
                  label="Last Name"
                  :value="user.last_name"
                  :on-change="onChange"
                />
              </v-flex>
            </v-layout>
            <v-layout
              row
              wrap
            >
              <v-flex
                xs12
                md6
              >
                <user-info
                  name="birth_name"
                  label="Birth name"
                  :value="user.birth_name"
                  :on-change="onChange"
                />
              </v-flex>

              <v-flex
                xs12
                md6
              >
                <user-info
                  name="legal_name"
                  label="Legal name"
                  :value="user.legal_name"
                  :on-change="onChange"
                />
              </v-flex>
            </v-layout>

            <v-layout
              row
              wrap
            >
              <v-flex
                xs6
                md3
              >
                <v-autocomplete
                  v-model="user.country_of_birth"
                  :items="countryCodesArray"
                  :search-input.sync="countryOfBirthSearch"
                  item-text="name"
                  item-value="backendValue"
                  label="Country of birth"
                  @change="e => onSelectChange(e, 'country_of_birth')"
                />
              </v-flex>
              <v-flex
                xs6
                md3
              >
                <v-select
                  v-model="user.marital_status"
                  :items="maritalStatusArray"
                  item-text="name"
                  item-value="value"
                  label="Marital Status"
                  @change="e => onSelectChange(e, 'marital_status')"
                />
              </v-flex>
              <v-flex
                xs12
                sm6
              >
                <v-radio-group
                  v-model="user.sex"
                  label="Gender"
                  row
                  wrap
                >
                  <v-radio
                    v-for="option in genderArray"
                    :key="option.value"
                    :label="option.name"
                    :value="option.value"
                    color="info"
                  />
                </v-radio-group>
              </v-flex>

              <v-flex
                xs12
                sm6
              >
                <user-info
                  name="miles_id"
                  label="Miles & More Servicekartennr"
                  :value="user.miles_id"
                  :on-change="onChange"
                />
              </v-flex>
            </v-layout>
            <v-layout
              row
              wrap
            >
              <v-flex
                xs4
                sm2
              >
                <user-info
                  name="legal_entity"
                  label="Legal entity"
                  :value="user.legal_entity"
                  :boolean-select="true"
                  :on-change="onChange"
                />
              </v-flex>
              <v-flex xs4>
                <user-info
                  name="email"
                  label="Email"
                  :value="user.email"
                  :on-change="onChange"
                />
              </v-flex>
              <v-flex xs3>
                <user-info
                  name="phone"
                  label="Phone"
                  :value="user.phone"
                  :on-change="onChange"
                />
              </v-flex>
              <v-flex xs3>
                <user-info
                  name="phone_mobile"
                  label="Phone mobile"
                  :value="user.phone_mobile"
                  :on-change="onChange"
                />
              </v-flex>
            </v-layout>
            <br>
            <h3>
              Address info
            </h3>
            <br>
            <v-layout
              row
              wrap
            >
              <v-flex
                xs12
                sm6
              >
                <user-info
                  name="city"
                  label="City"
                  :value="user.city"
                  :on-change="onChange"
                />
              </v-flex>
              <v-flex
                xs12
                sm6
              >
                <user-info
                  name="street"
                  label="Street"
                  :value="user.street"
                  :on-change="onChange"
                />
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex
                xs12
                sm6
              >
                <user-info
                  name="street_no"
                  label="Street Nº"
                  :value="user.street_no"
                  :on-change="onChange"
                />
              </v-flex>
              <v-flex
                xs12
                sm6
              >
                <user-info
                  name="postal_code"
                  label="Postal code"
                  :value="user.postal_code"
                  :on-change="onChange"
                />
              </v-flex>
              <v-flex xs4>
                <v-autocomplete
                  v-model="user.country"
                  :items="countryCodesArray"
                  :search-input.sync="countrySearch"
                  item-text="name"
                  item-value="backendValue"
                  label="Country"
                  @change="e => onSelectChange(e, 'country')"
                />
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex
                xs12
                sm12
              >
                <user-info
                  name="street_additional"
                  label="Street Additional"
                  :value="user.street_additional"
                  :on-change="onChange"
                />
              </v-flex>
            </v-layout>
            <br>
            <h3>
              ID document
            </h3>
            <br>
            <v-layout
              row
              wrap
            >
              <v-flex xs4>
                <user-info
                  name="pass"
                  label="Pass"
                  :value="user.pass"
                  :on-change="onChange"
                />
              </v-flex>
              <v-flex xs4>
                <v-menu
                  v-model="pickerCreatedAtOpen"
                  :close-on-content-click="false"
                  full-width
                  max-width="290"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      :value="formatDateLabel(user.pass_created_at)"
                      label="Pass created at"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    :value="formatDate(user.pass_created_at)"
                    :max="todaysDate"
                    show-current
                    color="info"
                    @change="e => onDatePickerChange(e, 'pass_created_at')"
                  />
                </v-menu>
              </v-flex>

              <v-flex xs4>
                <v-menu
                  v-model="pickerPassExpiresAtOpen"
                  :close-on-content-click="false"
                  full-width
                  max-width="290"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      :value="formatDateLabel(user.pass_expires_at)"
                      label="Pass expires at"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    :value="formatDate(user.pass_expires_at)"
                    show-current
                    color="info"
                    @change="e => onDatePickerChange(e, 'pass_expires_at')"
                  />
                </v-menu>
              </v-flex>
            </v-layout>

            <v-layout
              row
              wrap
            >
              <v-flex xs6>
                <v-select
                  v-model="user.legitimation_document"
                  :items="legitimationDocumentArray"
                  item-text="name"
                  item-value="value"
                  label="Legitimation document"
                  @change="e => onSelectChange(e, 'legitimation_document')"
                />
              </v-flex>
              <v-flex xs6>
                <v-autocomplete
                  v-model="user.citizenship"
                  :items="countryCodesArray"
                  :search-input.sync="citizenshipSearch"
                  item-text="name"
                  item-value="backendValue"
                  label="Citizenship"
                  @change="e => onSelectChange(e, 'citizenship')"
                />
              </v-flex>
            </v-layout>

            <v-layout
              row
              wrap
            >
              <v-flex xs6>
                <v-autocomplete
                  v-model="user.pass_country_of_issue"
                  :items="countryCodesArray"
                  :search-input.sync="countryOfPassSearch"
                  item-text="name"
                  item-value="backendValue"
                  label="Pass country of issue"
                  @change="e => onSelectChange(e, 'pass_country_of_issue')"
                />
              </v-flex>
              <v-flex xs6>
                <user-info
                  name="pass_authority"
                  label="Pass authority"
                  :value="user.pass_authority"
                  :on-change="onChange"
                />
              </v-flex>
            </v-layout>
            <v-layout
              row
              wrap
            >
              <v-flex xs6>
                <v-menu
                  v-model="pickerBirthDateOpen"
                  :close-on-content-click="false"
                  full-width
                  max-width="290"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      :value="formatDateLabel(user.dob)"
                      label="Date of birth"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    :value="formatDate(user.dob)"
                    :max="todaysDate"
                    show-current
                    color="info"
                    @change="e => onDatePickerChange(e, 'dob')"
                  />
                </v-menu>
              </v-flex>
              <v-flex xs6>
                <user-info
                  name="pob"
                  label="Place of birth"
                  :value="user.pob"
                  :on-change="onChange"
                />
              </v-flex>
            </v-layout>
            <br>
            <h3>
              Tax information
            </h3>
            <br>
            <v-layout
              row
              wrap
            >
              <v-flex
                xs6
                md3
              >
                <v-select
                  v-model="user.pep"
                  :items="[
                    { text: 'true', value: true },
                    { text: 'false', value: false }
                  ]"
                  name="pep"
                  label="PEP"
                  @change="e => onSelectChange(e, 'pep')"
                />
              </v-flex>
              <v-flex
                xs6
                md3
              >
                <v-select
                  v-model="user.pep_is_verified"
                  :items="[
                    { text: 'true', value: 1 },
                    { text: 'false', value: 0 }
                  ]"
                  name="pep_is_verified"
                  label="PEP verified"
                  @change="e => onSelectChange(e, 'pep_is_verified')"
                />
              </v-flex>

              <v-flex
                xs6
                md3
              >
                <v-select
                  v-model="user.not_us_taxed"
                  :items="[
                    { text: 'true', value: true },
                    { text: 'false', value: false }
                  ]"
                  name="not_us_taxed"
                  label="Not US taxed"
                  color="blue"
                  @change="e => onSelectChange(e, 'not_us_taxed')"
                />
              </v-flex>
              <v-flex
                xs6
                md3
              >
                <user-info
                  name="tax_id"
                  label="Tax ID"
                  :value="user.tax_id"
                  :on-change="onChange"
                />
              </v-flex>
            </v-layout>
            <br>
            <h3>
              Affiliation
            </h3>
            <br>
            <v-layout
              row
              wrap
            >
              <v-flex xs4>
                <user-info
                  name="affiliated_partner_id"
                  label="Affiliation Partner ID"
                  :value="user.affiliated_partner_id"
                  :on-change="onChange"
                />
              </v-flex>
              <v-flex xs4>
                <user-info
                  name="friend_id"
                  label="Friend ID"
                  :value="user.friend_id"
                  :on-change="onChange"
                />
              </v-flex>
              <v-flex xs4>
                <user-info
                  name="a_aid_ref"
                  label="AID ref"
                  :value="user.a_aid_ref"
                  :on-change="onChange"
                />
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-expansion-panel-content>
      <!-- Information end -->

      <!-- Trade Account start -->
      <v-expansion-panel-content>
        <template v-slot:header>
          <h6 class="title">
            <v-icon
              class="mr-2"
            >
              cached
            </v-icon>
            Trade Account
          </h6>
        </template>

        <v-card>
          <v-container
            fluid
            grid-list-sm
          >
            <v-layout
              v-if="isEmptyTradeAccount"
              row
              wrap
            >
              <v-flex xs12>
                <v-alert
                  :value="true"
                  type="error"
                  color="error"
                >
                  {{ "Empty Data!" }}
                </v-alert>
              </v-flex>
            </v-layout>
            <v-layout
              v-else
              row
              wrap
            >
              <v-flex
                xs12
                sm6
              >
                <v-text-field
                  label="SNR"
                  :editable="false"
                  :value="tradeAccount.snr ? tradeAccount.snr : ''"
                  readonly
                  append-icon="link"
                  @click:append="goToBaaderSNRPage(tradeAccount.snr)"
                />
              </v-flex>

              <v-flex
                xs12
                sm6
              >
                <user-info
                  label="Account Number"
                  :value="tradeAccount.KTO"
                  readonly
                />
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-expansion-panel-content>
      <!-- Trade Account end -->

      <!-- Signings start -->
      <v-expansion-panel-content>
        <template v-slot:header>
          <h6 class="title">
            <v-icon
              class="mr-2"
            >
              assignment_ind
            </v-icon>
            Signings
            <b>({{ signings ? signings.length || 0 : 0 }})</b>
          </h6>
        </template>

        <v-card>
          <v-container
            v-for="(item, index) in signings"
            :key="index"
            grid-list-md
          >
            <user-sign-detail :detail="item" />
            <v-divider :key="index" />
          </v-container>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <!-- Signings end -->

    <v-dialog
      v-model="modalOpen"
      width="400"
      persistent
    >
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          Confirm customer data change?
        </v-card-title>

        <v-form
          ref="processOrderForm"
          @submit.prevent="saveUserData"
        >
          <v-divider />
          <p class="text-xs-justify ma-2">
            Please make sure this data change will not affect other processes
            regarding this cutomer. Type user ID in field below to confirm this
            change.
          </p>

          <v-text-field
            v-model="userIdConfirmValue"
            :error-messages="userIdConfirmError"
            class="text-xs-justify ma-2"
            label="User ID"
            required
          />
          <v-card-actions>
            <v-spacer />
            <v-btn
              flat
              @click="modalOpen = false"
            >
              Close
            </v-btn>
            <e-button
              flat
              type="submit"
              color="blue"
              text="Save"
            />
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { Button } from '@/components/shared';
import { countryCodesArray } from '@/enum/CountryCodesEnum';
import { maritalStatusArray } from '@/enum/user/MaritalStatus';
import { titlesArray } from '@/enum/user/Title';
import { genderArray } from '@/enum/user/Gender';
import { legitimationDocumentArray } from '@/enum/user/LegitimationDocument';

import UserInfo from './UserInfo.vue';
import UserSignDetail from './UserSignDetail.vue';

export default {
  name: 'UserDetailComponent',
  components: {
    'user-info': UserInfo,
    'user-sign-detail': UserSignDetail,
    'e-button': Button,
  },
  props: {
    user: {
      type: Object,
      default: () => ({}),
    },
    tradeAccount: {
      type: Object,
      default: () => ({}),
    },
    upvestAccount: {
      type: Object,
      default: () => ({}),
    },
    signings: {
      type: Array,
      default: () => [],
    },
    onChangeUser: {
      type: Function,
      default: () => ({}),
    },
  },
  data() {
    return {
      panel: [],
      modalOpen: false,
      unsavedData: false,
      resetPasswordRequestInProgress: false,
      pickerBirthDateOpen: false,
      pickerCreatedAtOpen: false,
      pickerPassExpiresAtOpen: false,
      todaysDate: new Date().toISOString().substr(0, 10),
      userIdConfirmValue: '',
      userIdConfirmError: '',
      countrySearch: '',
      countryOfBirthSearch: '',
      countryOfPassSearch: '',
      citizenshipSearch: '',
      countryCodesArray,
      maritalStatusArray,
      titlesArray,
      genderArray,
      legitimationDocumentArray,
      dataToSave: {},
    };
  },
  computed: {
    isEmptyTradeAccount() {
      return Object.keys(this.tradeAccount).length === 0;
    },
    isEmptyUpvestAccount() {
      return Object.keys(this.upvestAccount).length === 0;
    },
  },
  mounted() {
    this.panel = [true, !this.isEmptyTradeAccount, false];
  },
  methods: {
    ...mapActions(['updateUserData', 'resetPassword']),
    formatDate(date) {
      return date ? this.$moment(date).format('YYYY-MM-DD') : null;
    },
    formatDateLabel(date) {
      return date ? this.$moment(date).format('Do MMMM, YYYY') : null;
    },
    goToBaaderSNRPage(snr) {
      this.$router.push({ name: 'baader_detail', params: { snr } });
    },
    onChange(data) {
      this.unsavedData = true;
      this.dataToSave[data.name] = data.value;
      this.onChangeUser(data);
    },
    onSelectChange(value, field) {
      this.unsavedData = true;
      this.dataToSave[field] = value;
      this.onChangeUser({ name: field, value });
    },
    onDatePickerChange(date, field) {
      this.unsavedData = true;
      this.dataToSave[field] = date;
      this.closePickers();
      this.onChangeUser({ name: field, value: this.$moment(date).format('YYYY-MM-DD hh:mm:ss') });
    },
    async resetPasswordClicked() {
      this.resetPasswordRequestInProgress = true;
      await this.resetPassword(this.user.id);
      this.resetPasswordRequestInProgress = false;
    },
    async saveUserData() {
      if (this.userIdConfirmValue === String(this.user.id)) {
        this.userIdConfirmError = '';
        this.userIdConfirmValue = '';
        this.modalOpen = false;
        this.dataToSave.id = this.user.id;
        await this.updateUserData(this.dataToSave);
        this.dataToSave = {};
        this.unsavedData = false;
      } else {
        this.userIdConfirmError = 'Does not match User ID.';
      }
    },
    openSaveUserDataModal() {
      this.modalOpen = true;
    },
    closePickers() {
      this.pickerBirthDateOpen = false;
      this.pickerCreatedAtOpen = false;
      this.pickerPassExpiresAtOpen = false;
    },
  },
};
</script>

<style lang='scss' scoped>
.subheading {
  color: grey;
}
</style>



// WEBPACK FOOTER //
// src/components/users/backend/UserDetailComponent.vue